import { fetchRegions } from "services/regionsHelper";

const CJK_SUFFIX_REGEX = /\s*[（(][^（）()]*[\u4e00-\u9fff][^（）()]*[）)]$/;
const TRAILING_ABBREVIATION_REGEX =
  /^(.*[\u4e00-\u9fff].*?)\s*(?:[-–—·]\s*)?[（(]?([A-Z][A-Z0-9&]+(?:\s[A-Z][A-Z0-9&]+)*)[）)]?$/;

const moveAbbreviationToFront = (name: string) => {
  if (!name || /^[A-Za-z]/.test(name)) return name;

  const suffix = name.match(CJK_SUFFIX_REGEX)?.[0] || "";
  const base = suffix ? name.slice(0, -suffix.length) : name;
  const match = base.match(TRAILING_ABBREVIATION_REGEX);
  if (!match) return name;

  const [, rest, abbreviation] = match;
  return `(${abbreviation}) ${rest.trim()}${suffix.trim()}`;
};

const translateResidentUniversities = async (inventoryData: any, userLanguage: string) => {
  const insights = inventoryData?.meta?.property_residents_insights;
  const uniDist = insights?.uni_dist;

  if (!userLanguage || userLanguage === "en" || !Array.isArray(uniDist) || uniDist.length === 0) {
    return;
  }

  const ids = uniDist.map((entry: any) => entry?.id).filter(Boolean);
  if (ids.length === 0) return;

  const res: any = await fetchRegions({
    ids: ids.join(","),
    lang: userLanguage,
    limit: ids.length,
  });

  const result = res?.data?.result;
  if (!Array.isArray(result) || result.length === 0) return;

  const translatedNameById = new Map<number, string>();
  result.forEach((region: any) => {
    if (region?.id && region?.name) {
      translatedNameById.set(region.id, region.name);
    }
  });

  insights.uni_dist = uniDist.map((entry: any) => {
    const translatedName = entry?.id ? translatedNameById.get(entry.id) : undefined;
    return translatedName && translatedName !== entry.name
      ? { ...entry, name: moveAbbreviationToFront(translatedName), name_en: entry.name }
      : entry;
  });
};

export default translateResidentUniversities;
